import { createSelector } from 'reselect';
import { getState } from './state';
export const getRoomSlice = createSelector([
    getState
], (slice)=>{
    return slice.room;
});
export const getActiveRoom = createSelector(getRoomSlice, (state)=>{
    return state === null || state === void 0 ? void 0 : state.activeRoom;
});
export const getLastActiveRoom = createSelector(getRoomSlice, (state)=>{
    return state === null || state === void 0 ? void 0 : state.prevActiveRoom;
});
export const getPresence = createSelector((state)=>getRoomSlice(state), (state, roomId)=>roomId, (state, roomId)=>{
    var _state_presence;
    var _state_presence_roomId;
    return (_state_presence_roomId = state === null || state === void 0 ? void 0 : (_state_presence = state.presence) === null || _state_presence === void 0 ? void 0 : _state_presence[roomId]) !== null && _state_presence_roomId !== void 0 ? _state_presence_roomId : {};
});
export const getMarkAsReadQueue = createSelector(getRoomSlice, (state)=>{
    return state === null || state === void 0 ? void 0 : state.markAsReadQueue;
});
export const getTypingText = createSelector(getRoomSlice, (state)=>{
    return state === null || state === void 0 ? void 0 : state.typingText;
});
export const getSentMsgMarker = createSelector(getRoomSlice, (state)=>{
    var _state_sentMarker;
    return (_state_sentMarker = state === null || state === void 0 ? void 0 : state.sentMarker) !== null && _state_sentMarker !== void 0 ? _state_sentMarker : 0;
});
export const getFocusMessageRequest = createSelector(getRoomSlice, (state)=>state.focusMessageRequest);

//# sourceMappingURL=room.js.map